import Modal from 'react-modal';
import "../../styles/AdminPage.css";
import Button, { BUTTON_TYPES } from '../Button';
import PropTypes from 'prop-types';
import React from 'react';
import { FaTimes } from "react-icons/fa";

Modal.setAppElement('#root');

const DeleteModal = ({ isOpen, onClose, itemToDelete, deleteAction, deleteAPICall, handleDelete }) => {

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Delete Modal"
            className="custom-modal-content delete-modal"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                    <h2 className="text-start mb-0">Are you sure?</h2>
                    <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                        <button className="close-btn" onClick={onClose}>{<FaTimes />}</button>
                    </div>
                </div>
                <div>
                    Are you sure you want to delete this item? This action cannot be undone.
                </div>
                <div className='d-flex flex-row justify-content-center align-items-center two-button-container'>
                    <div className='me-3'>
                        <Button
                            id="filter-button-modal"
                            type={BUTTON_TYPES.outline}
                            buttonText="Cancel"
                            action={() => { onClose() }}
                        />
                    </div>
                    <Button
                        id="delete-committee-confirm-button"
                        type={BUTTON_TYPES.danger}
                        buttonText="Confirm"
                        action={() => { handleDelete(deleteAPICall, itemToDelete.id) }}
                    />
                </div>
            </>
        </Modal>
    );
};

DeleteModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default DeleteModal;
